"use client";

import React, { Fragment } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import Header from "../../components/Header";
import Leftnav from "../../components/Leftnav";
import ProfileCardTournament from "../../components/ProfilecardTournament";
import TournamentInscriptionList from "../../components/TournamentInscriptionList";
import { PAGAMENTO_POR_ID, PagamentoPorIdData, PagamentoPorIdVars } from "../../services/pagamentoInscricaoService";
import Load from "../../components/Load";

const TournamentInscriptions: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const { data, loading, error } = useQuery<PagamentoPorIdData, PagamentoPorIdVars>(
    PAGAMENTO_POR_ID,
    {
      variables: { id: id || "" },
      skip: !id,
    }
  );

  const pagamento = data?.pagamentoInscricaoPorId;
  const torneioRaw = pagamento?.inscricoes[0]?.categoriaTorneio?.torneio;
  const torneio = torneioRaw
    ? {
        ...torneioRaw,
        local: torneioRaw.local || "",
        dataInicio: torneioRaw.dataInicio ?? "", // Ensure dataInicio is always a string
        dataFim: torneioRaw.dataFim ?? undefined, // Ensure dataFim is string or undefined, never null
      }
    : undefined;

  return (
    <Fragment>
      <Header />
      {/* <Leftnav /> */}
      <div className="main-content right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left pe-0">
            <div className="row">
              <div className="col-xl-12 col-xxl-12 col-lg-12">
                {loading && <Load />}
                {error && (
                  <div className="alert alert-danger" role="alert">
                    Erro ao carregar pagamento.
                  </div>
                )}
                {torneio && <ProfileCardTournament torneio={torneio} />}
              </div>
            </div>
            {id && <TournamentInscriptionList pagamentoId={id} />}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default TournamentInscriptions;
